/* eslint-disable no-console */
import axios from 'axios';
import $ from 'jquery';
import { lazyContentLoaded } from '../_helpers/constants';

export default class LazyLoadService {
  async _getLazyModule(moduleConfig) {
    const data = {
      data: JSON.stringify(moduleConfig),
    };

    try {
      return await axios({
        method: 'get',
        url: '/api/lazy/load',
        params: data,
        responseType: 'text',
      });
    } catch (e) {
      console.error(e);
    }
  }

  _getModuleConfig($target) {
    if (!$target[0].hasAttribute('data-json-module')) {
      return {};
    }
    return JSON.parse($target[0].getAttribute('data-json-module'));
  }

  _addContentToTarget($target, newHtml) {
    $target.html(newHtml);
  }

  _replaceContentToTarget($target, newHtml) {
    $target.replaceWith(newHtml);
  }

  _appendAfterResponse($target, newHtml) {
    $target.after(newHtml);
  }

  _refactorContent($responseContent) {
    for (let i = 1; i < $responseContent.length; i++) {
      if (typeof $responseContent[i].dataset !== 'undefined') {
        this._appendAfterResponse($($responseContent[0]), $responseContent[i]);
      }
    }
  }

  async initByElement(
    hasMultiple,
    targetElement,
    replaceContent,
    removeDataPluginAttr,
    removeDataJsonAttr,
    removeDataOptions,
    leaveContentOnError
  ) {
    const plugin = {};

    plugin.$target = $(targetElement);
    plugin.moduleConfig = this._getModuleConfig(plugin.$target);

    const response = await this._getLazyModule(plugin.moduleConfig);
    if (!response) return;

    const $responseContent = $(response.data);

    if (removeDataPluginAttr) {
      $responseContent.removeAttr('data-plugin');
    }

    if (removeDataJsonAttr) {
      $responseContent.removeAttr('data-json-module');
    }

    if (removeDataOptions) {
      $responseContent.removeAttr('data-options');
    }

    let shownContent = $responseContent[0];
    if (hasMultiple) {
      shownContent = $responseContent;
    }

    if (replaceContent) {
      if (!(leaveContentOnError && shownContent === undefined)) {
        this._replaceContentToTarget(plugin.$target, shownContent);
      }
    } else {
      this._addContentToTarget(plugin.$target, shownContent);
    }

    // Add another element in DOM
    if (!hasMultiple && $responseContent.length > 0) {
      _refactorContent($responseContent);
    }
    $(window).trigger(lazyContentLoaded, {});

    return response.data;

  }
}
